export const SigSymbol = Symbol('[SIG]');
export const RenderedRootSymbol = Symbol('[RR]');
export const ElementKeySymbol =  Symbol('[ELEMENT_KEY]');

export const ForControlFlow = Symbol('ForControlFlow');
export const IfControlFlow = Symbol('IfControlFlow');
export const AwaitControlFlow = Symbol('AwaitControlFlow');
export const SSRSymbol = Symbol('SSR');
